import { render, staticRenderFns } from "./orderEdit.vue?vue&type=template&id=2fab8a1a&scoped=true&"
import script from "./orderEdit.vue?vue&type=script&lang=js&"
export * from "./orderEdit.vue?vue&type=script&lang=js&"
import style0 from "./orderEdit.vue?vue&type=style&index=0&id=2fab8a1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fab8a1a",
  null
  
)

export default component.exports